import { Controller } from "@hotwired/stimulus"

// Checkbox-driven multi-select + bulk delete for the recent-scans
// list on /gridsignal/scans/new.
//
// Markup contract:
//   <div data-controller="gs-scan-list">
//     <input type="checkbox" data-gs-scan-list-target="all" data-action="change->gs-scan-list#toggleAll">
//     <input type="checkbox" data-gs-scan-list-target="row" data-action="change->gs-scan-list#updateToolbar" value="42">
//     <div data-gs-scan-list-target="toolbar" hidden>
//       <span data-gs-scan-list-target="count">0</span>
//       <form data-gs-scan-list-target="form" ...>
//         <input type="hidden" name="ids[]" data-gs-scan-list-target="idsField">
//       </form>
//     </div>
//   </div>
export default class extends Controller {
  static targets = ["all", "row", "toolbar", "count", "form"]

  toggleAll(event) {
    const checked = event.currentTarget.checked
    this.rowTargets.forEach((cb) => { cb.checked = checked })
    this.updateToolbar()
  }

  updateToolbar() {
    const selected = this.rowTargets.filter((cb) => cb.checked)
    const n = selected.length

    if (this.hasCountTarget) this.countTarget.textContent = n.toString()

    if (this.hasToolbarTarget) this.toolbarTarget.hidden = n === 0

    // Keep the all-checkbox in sync (indeterminate when partial).
    if (this.hasAllTarget) {
      const total = this.rowTargets.length
      this.allTarget.checked = n > 0 && n === total
      this.allTarget.indeterminate = n > 0 && n < total
    }

    // Rebuild the hidden ids[] fields on the form so the submit
    // carries exactly the current selection.
    if (this.hasFormTarget) {
      // Remove any existing ids[] inputs so we don't double-submit.
      this.formTarget.querySelectorAll('input[name="ids[]"]').forEach((el) => el.remove())
      selected.forEach((cb) => {
        const input = document.createElement("input")
        input.type  = "hidden"
        input.name  = "ids[]"
        input.value = cb.value
        this.formTarget.appendChild(input)
      })
    }
  }

  confirmBulk(event) {
    const selected = this.rowTargets.filter((cb) => cb.checked)
    if (selected.length === 0) {
      event.preventDefault()
      return
    }
    const label = selected.length === 1 ? "this scan" : `these ${selected.length} scans`
    if (!confirm(`Remove ${label} from your recent scans? You can re-scan this market anytime.`)) {
      event.preventDefault()
    }
  }
}
